// GENERATED by tools/brand-gold/emit_tsx.py — do not edit.
// Source: brand/bime-gold/traced/svg/logo.svg. Re-run tools/brand-gold/build.sh.

/**
 * The full Bime Gold lockup. This is the default — use it anywhere it fits.
 * `bime` is `currentColor`, so set the colour with a text utility; `gold` and the
 * tittle are always brand gold. Wider than tall — size it with a height, e.g. `h-7 w-auto`.
 */
export const BrandLogo = ({ className }: { className?: string }) => (
  <svg viewBox="0 0 1093 328" className={className} role="img" aria-label="بیمه گلد">
    <g transform="scale(0.25) translate(0.000000,1312.000000) scale(0.100000,-0.100000)"><path fill="currentColor" fillRule="evenodd" d="M107 12930 l-27 -29 2 -5248 3 -5248 1832 -3 c1824 -2 1832 -2 1843
18 9 18 21 20 100 20 79 0 91 2 100 20 9 17 21 20 80 20 59 0 71 3 80 20 7 13
21 20 40 20 19 0 33 7 40 20 8 16 21 20 60 20 39 0 52 4 60 20 7 12 21 20 38
20 19 0 37 12 62 40 25 28 43 40 62 40 17 0 31 8 38 20 6 12 21 20 36 20 19 0
43 17 84 60 35 37 66 60 79 60 29 0 161 132 161 161 0 13 30 50 80 99 55 53
80 86 80 102 0 14 15 36 40 58 28 25 40 43 40 62 0 17 8 31 20 38 13 7 20 21
20 40 0 19 7 33 20 40 16 8 20 21 20 60 0 39 4 52 20 60 13 7 20 21 20 40 0
19 7 33 20 40 17 9 20 21 20 80 0 59 3 71 20 80 17 9 20 21 20 80 0 59 3 71
20 80 20 11 20 21 20 2660 0 2639 0 2649 -20 2660 -18 9 -20 21 -20 100 0 79
-2 91 -20 100 -16 8 -20 21 -20 60 0 39 -4 52 -20 60 -16 8 -20 21 -20 60 0
39 -4 52 -20 60 -13 7 -20 21 -20 40 0 19 -7 33 -20 40 -12 7 -20 21 -20 38 0
19 -12 37 -40 62 -26 23 -40 44 -40 60 0 16 -14 37 -40 60 -24 21 -40 44 -40
58 0 30 -251 282 -281 282 -13 0 -44 24 -79 60 -38 40 -66 60 -81 60 -15 0
-37 15 -59 40 -25 28 -43 40 -62 40 -17 0 -31 8 -38 20 -7 13 -21 20 -40 20
-19 0 -33 7 -40 20 -8 16 -21 20 -60 20 -39 0 -52 4 -60 20 -7 13 -21 20 -40
20 -19 0 -33 7 -40 20 -9 17 -21 20 -80 20 -59 0 -71 3 -80 20 -9 17 -21 20
-80 20 -59 0 -71 3 -80 20 -10 18 -21 20 -140 20 -119 0 -130 2 -140 20 -10
20 -23 20 -843 22 l-832 3 -5 1055 -5 1055 -850 2 -850 2 -28 -29z m3173
-3590 c7 -13 21 -20 40 -20 19 0 33 -7 40 -20 6 -12 21 -20 36 -20 34 0 124
-90 124 -124 0 -15 8 -30 20 -36 13 -7 20 -21 20 -40 0 -19 7 -33 20 -40 13
-7 20 -21 20 -40 0 -19 7 -33 20 -40 20 -11 20 -21 20 -2320 0 -2299 0 -2309
-20 -2320 -17 -9 -20 -21 -20 -80 0 -59 -3 -71 -20 -80 -12 -6 -20 -21 -20
-36 0 -18 -29 -53 -110 -134 -107 -107 -111 -110 -154 -110 -35 0 -48 -5 -56
-20 -11 -20 -19 -20 -703 -18 l-692 3 -3 2745 c-1 1510 0 2751 3 2758 3 9 156
12 714 12 700 0 710 0 721 -20z M5965 10828 c-3 -7 -4 -1905 -3 -4218 l3
-4205 855 0 855 0 0 4215 0 4215 -853 3 c-677 2 -854 0 -857 -10z M8307 10810
l-27 -29 2 -4188 3 -4188 875 0 875 0 5 3475 5 3475 692 3 c684 2 692 2 703
-18 7 -13 21 -20 40 -20 19 0 33 -7 40 -20 6 -12 21 -20 36 -20 35 0 204 -169
204 -204 0 -15 8 -30 20 -36 16 -8 20 -21 20 -60 0 -39 4 -52 20 -60 20 -11
20 -23 22 -3263 l3 -3252 875 0 875 0 3 3272 c2 3260 2 3272 22 3283 16 8 20
21 20 60 0 39 4 52 20 60 12 6 20 21 20 36 0 35 129 164 164 164 15 0 30 8 36
20 7 13 21 20 40 20 19 0 33 7 40 20 10 20 21 20 520 20 499 0 510 0 520 -20
8 -15 21 -20 56 -20 43 0 47 -3 154 -110 81 -81 110 -116 110 -134 0 -15 8
-30 20 -36 16 -8 20 -21 20 -60 0 -39 4 -52 20 -60 20 -11 20 -23 22 -3263 l3
-3252 875 0 875 0 3 3312 c2 3304 2 3312 -18 3323 -19 10 -20 21 -20 160 0
139 -1 150 -20 160 -17 9 -20 21 -20 80 0 59 -3 71 -20 80 -13 7 -20 21 -20
40 0 19 -7 33 -20 40 -16 8 -20 21 -20 60 0 39 -4 52 -20 60 -13 7 -20 21 -20
40 0 19 -7 33 -20 40 -13 7 -20 21 -20 40 0 19 -7 33 -20 40 -12 6 -20 21 -20
36 0 19 -17 43 -60 84 -36 35 -60 66 -60 79 0 31 -292 321 -322 321 -14 0 -37
16 -58 40 -25 28 -43 40 -62 40 -17 0 -31 8 -38 20 -7 12 -21 20 -38 20 -19 0
-37 12 -62 40 -25 28 -43 40 -62 40 -17 0 -31 8 -38 20 -8 16 -21 20 -60 20
-39 0 -52 4 -60 20 -7 13 -21 20 -40 20 -19 0 -33 7 -40 20 -9 17 -21 20 -80
20 -59 0 -71 3 -80 20 -9 17 -21 20 -80 20 -59 0 -71 3 -80 20 -10 18 -21 20
-120 20 -99 0 -110 2 -120 20 -11 20 -21 20 -780 20 -759 0 -769 0 -780 -20
-10 -18 -21 -20 -140 -20 -119 0 -130 -2 -140 -20 -9 -17 -21 -20 -80 -20 -59
0 -71 -3 -80 -20 -8 -16 -21 -20 -60 -20 -39 0 -52 -4 -60 -20 -8 -16 -21 -20
-60 -20 -39 0 -52 -4 -60 -20 -7 -13 -21 -20 -40 -20 -19 0 -33 -7 -40 -20 -7
-13 -21 -20 -40 -20 -19 0 -33 -7 -40 -20 -7 -13 -21 -20 -40 -20 -19 0 -33
-7 -40 -20 -6 -12 -21 -20 -36 -20 -14 0 -34 -10 -45 -22 l-19 -23 -19 23
c-11 12 -31 22 -45 22 -15 0 -30 8 -36 20 -7 13 -21 20 -40 20 -19 0 -33 7
-40 20 -7 13 -21 20 -40 20 -19 0 -33 7 -40 20 -7 13 -21 20 -40 20 -19 0 -33
7 -40 20 -8 16 -21 20 -60 20 -39 0 -52 4 -60 20 -8 16 -21 20 -60 20 -39 0
-52 4 -60 20 -9 17 -21 20 -80 20 -59 0 -71 3 -80 20 -10 19 -21 20 -160 20
-139 0 -150 1 -160 20 -11 20 -21 20 -1678 20 l-1667 -1 -28 -29z M19560
10820 c-10 -18 -21 -20 -140 -20 -119 0 -130 -2 -140 -20 -9 -17 -21 -20 -80
-20 -59 0 -71 -3 -80 -20 -8 -16 -21 -20 -60 -20 -39 0 -52 -4 -60 -20 -8 -16
-21 -20 -60 -20 -39 0 -52 -4 -60 -20 -7 -13 -21 -20 -40 -20 -19 0 -33 -7
-40 -20 -8 -16 -21 -20 -58 -20 -42 0 -51 -4 -82 -40 -25 -28 -43 -40 -62 -40
-17 0 -31 -8 -38 -20 -6 -12 -21 -20 -36 -20 -19 0 -43 -17 -84 -60 -35 -36
-66 -60 -79 -60 -30 0 -241 -212 -241 -242 0 -14 -16 -37 -40 -58 -26 -23 -40
-44 -40 -60 0 -16 -14 -37 -40 -60 -28 -25 -40 -43 -40 -62 0 -17 -8 -31 -20
-38 -13 -7 -20 -21 -20 -40 0 -19 -7 -33 -20 -40 -13 -7 -20 -21 -20 -40 0
-19 -7 -33 -20 -40 -16 -8 -20 -21 -20 -60 0 -39 -4 -52 -20 -60 -16 -8 -20
-21 -20 -60 0 -39 -4 -52 -20 -60 -18 -9 -20 -21 -20 -100 0 -79 -2 -91 -20
-100 -20 -11 -20 -21 -20 -2620 0 -2599 0 -2609 20 -2620 18 -9 20 -21 20
-100 0 -79 2 -91 20 -100 17 -9 20 -21 20 -80 0 -59 3 -71 20 -80 13 -7 20
-21 20 -40 0 -19 7 -33 20 -40 13 -7 20 -21 20 -40 0 -19 7 -33 20 -40 13 -7
20 -21 20 -40 0 -19 7 -33 20 -40 13 -7 20 -21 20 -40 0 -19 7 -33 20 -40 12
-7 20 -21 20 -38 0 -19 12 -37 40 -62 24 -21 40 -44 40 -58 0 -33 371 -402
405 -402 14 0 29 -8 35 -20 7 -12 21 -20 38 -20 19 0 37 -12 62 -40 25 -28 43
-40 62 -40 17 0 31 -8 38 -20 7 -13 21 -20 40 -20 19 0 33 -7 40 -20 8 -16 21
-20 60 -20 39 0 52 -4 60 -20 7 -13 21 -20 40 -20 19 0 33 -7 40 -20 9 -17 21
-20 80 -20 59 0 71 -3 80 -20 9 -17 21 -20 80 -20 59 0 71 -3 80 -20 11 -20
21 -20 1060 -20 1039 0 1049 0 1060 20 9 17 21 20 80 20 59 0 71 3 80 20 8 16
21 20 60 20 39 0 52 4 60 20 8 16 21 20 60 20 39 0 52 4 60 20 7 13 21 20 40
20 19 0 33 7 40 20 8 16 21 20 58 20 42 0 51 4 82 40 25 28 43 40 62 40 17 0
31 8 38 20 6 12 21 20 36 20 19 0 47 21 104 80 49 50 86 80 99 80 29 0 161
132 161 161 0 13 23 44 60 79 40 38 60 66 60 81 0 15 15 37 40 59 28 25 40 43
40 62 0 17 8 31 20 38 13 7 20 21 20 40 0 19 7 33 20 40 13 7 20 21 20 40 0
19 7 33 20 40 13 7 20 21 20 40 0 19 7 33 20 40 16 8 20 21 20 60 0 39 4 52
20 60 18 9 20 21 20 100 0 79 2 91 20 100 20 11 20 19 18 503 l-3 492 -855 0
-855 0 -3 -312 c-2 -300 -3 -313 -22 -323 -16 -8 -20 -21 -20 -60 0 -39 -4
-52 -20 -60 -12 -6 -20 -21 -20 -36 0 -35 -169 -204 -204 -204 -15 0 -30 -8
-36 -20 -7 -13 -21 -20 -40 -20 -19 0 -33 -7 -40 -20 -10 -20 -21 -20 -520
-20 -499 0 -510 0 -520 20 -8 15 -21 20 -56 20 -43 0 -47 3 -154 110 -81 81
-110 116 -110 134 0 15 -8 30 -20 36 -17 9 -20 21 -20 80 0 59 -3 71 -20 80
-20 11 -20 19 -18 763 l3 752 1775 5 1775 5 3 1732 c2 1724 2 1732 -18 1743
-17 9 -20 21 -20 80 0 59 -3 71 -20 80 -16 8 -20 21 -20 60 0 39 -4 52 -20 60
-13 7 -20 21 -20 40 0 19 -7 33 -20 40 -16 8 -20 21 -20 58 0 42 -4 51 -40 82
-28 25 -40 43 -40 62 0 17 -8 31 -20 38 -12 7 -20 21 -20 38 0 19 -12 37 -40
62 -24 21 -40 44 -40 58 0 31 -291 322 -322 322 -14 0 -37 16 -58 40 -23 26
-44 40 -60 40 -16 0 -37 14 -60 40 -25 28 -43 40 -62 40 -17 0 -31 8 -38 20
-7 13 -21 20 -40 20 -19 0 -33 7 -40 20 -8 16 -21 20 -60 20 -39 0 -52 4 -60
20 -7 13 -21 20 -40 20 -19 0 -33 7 -40 20 -9 17 -21 20 -80 20 -59 0 -71 3
-80 20 -9 17 -21 20 -80 20 -59 0 -71 3 -80 20 -10 18 -21 20 -140 20 -119 0
-130 2 -140 20 -11 20 -21 20 -800 20 -779 0 -789 0 -800 -20z m720 -1440 c10
-19 21 -20 320 -20 299 0 310 -1 320 -20 7 -12 21 -20 38 -20 19 0 37 -12 62
-40 22 -25 44 -40 58 -40 32 0 82 -52 82 -84 0 -15 8 -30 20 -36 13 -7 20 -21
20 -40 0 -19 7 -33 20 -40 17 -9 20 -21 20 -80 0 -59 3 -71 20 -80 20 -11 20
-19 18 -803 l-3 -792 -888 -3 -888 -2 -30 29 -29 29 0 766 c0 755 0 765 20
776 17 9 20 21 20 80 0 59 3 71 20 80 12 6 20 21 20 36 0 18 29 53 110 134
107 107 111 110 154 110 35 0 48 5 56 20 10 18 21 20 120 20 99 0 110 2 120
20 9 18 21 20 100 20 79 0 91 -2 100 -20z"/></g><g transform="scale(0.25) translate(0.000000,1312.000000) scale(0.100000,-0.100000)"><path fill="#D4AF37" fillRule="evenodd" d="M6640 12980 c-9 -17 -21 -20 -80 -20 -59 0 -71 -3 -80 -20 -7 -12
-21 -20 -38 -20 -19 0 -37 -12 -62 -40 -21 -24 -44 -40 -58 -40 -31 0 -162
-131 -162 -162 0 -14 -16 -37 -40 -58 -28 -25 -40 -43 -40 -62 0 -17 -8 -31
-20 -38 -13 -7 -20 -21 -20 -40 0 -19 -7 -33 -20 -40 -17 -9 -20 -21 -20 -80
0 -59 -3 -71 -20 -80 -18 -10 -20 -21 -20 -120 0 -99 2 -110 20 -120 17 -9 20
-21 20 -80 0 -59 3 -71 20 -80 13 -7 20 -21 20 -40 0 -19 7 -33 20 -40 12 -6
20 -21 20 -36 0 -33 249 -284 282 -284 14 0 37 -16 58 -40 31 -36 40 -40 82
-40 37 0 50 -4 58 -20 10 -19 21 -20 280 -20 259 0 270 1 280 20 7 13 21 20
40 20 19 0 33 7 40 20 7 12 21 20 38 20 19 0 37 12 62 40 21 24 44 40 58 40
31 0 162 131 162 162 0 14 16 37 40 58 28 25 40 43 40 62 0 17 8 31 20 38 17
9 20 21 20 80 0 59 3 71 20 80 19 10 20 21 20 160 0 139 -1 150 -20 160 -17 9
-20 21 -20 80 0 59 -3 71 -20 80 -13 7 -20 21 -20 40 0 19 -7 33 -20 40 -12 6
-20 21 -20 36 0 35 -249 284 -284 284 -15 0 -30 8 -36 20 -7 13 -21 20 -40 20
-19 0 -33 7 -40 20 -9 17 -21 20 -80 20 -59 0 -71 3 -80 20 -10 19 -21 20
-180 20 -159 0 -170 -1 -180 -20z"/></g><g transform="scale(0.25) translate(0.000000,1312.000000) scale(0.100000,-0.100000)"><path fill="#D4AF37" fillRule="evenodd" d="M36165 12948 c-3 -7 -4 -2382 -3 -5278 l3 -5265 875 0 875 0 3 5248
2 5249 -29 29 -29 29 -847 0 c-667 0 -847 -3 -850 -12z M41927 12953 c-4 -3
-7 -37 -7 -74 0 -58 -3 -70 -20 -79 -20 -11 -20 -23 -22 -983 l-3 -972 -812
-3 c-800 -2 -813 -2 -823 -22 -10 -18 -21 -20 -120 -20 -99 0 -110 -2 -120
-20 -9 -18 -21 -20 -100 -20 -79 0 -91 -2 -100 -20 -8 -16 -21 -20 -60 -20
-39 0 -52 -4 -60 -20 -8 -16 -21 -20 -60 -20 -39 0 -52 -4 -60 -20 -7 -13 -21
-20 -40 -20 -19 0 -33 -7 -40 -20 -7 -13 -21 -20 -40 -20 -19 0 -33 -7 -40
-20 -7 -13 -21 -20 -40 -20 -19 0 -33 -7 -40 -20 -7 -12 -21 -20 -38 -20 -19
0 -37 -12 -62 -40 -21 -24 -44 -40 -58 -40 -32 0 -402 -370 -402 -402 0 -14
-16 -37 -40 -58 -28 -25 -40 -43 -40 -62 0 -17 -8 -31 -20 -38 -13 -7 -20 -21
-20 -40 0 -19 -7 -33 -20 -40 -13 -7 -20 -21 -20 -40 0 -19 -7 -33 -20 -40
-16 -8 -20 -21 -20 -60 0 -39 -4 -52 -20 -60 -16 -8 -20 -21 -20 -60 0 -39 -4
-52 -20 -60 -18 -9 -20 -21 -20 -100 0 -79 -2 -91 -20 -100 -20 -11 -20 -21
-20 -2640 0 -2619 0 -2629 20 -2640 18 -9 20 -21 20 -100 0 -79 2 -91 20 -100
17 -9 20 -21 20 -80 0 -59 3 -71 20 -80 16 -8 20 -21 20 -60 0 -39 4 -52 20
-60 13 -7 20 -21 20 -40 0 -19 7 -33 20 -40 13 -7 20 -21 20 -40 0 -19 7 -33
20 -40 12 -7 20 -21 20 -38 0 -19 12 -37 40 -62 25 -22 40 -44 40 -58 0 -16
25 -49 80 -102 51 -49 80 -86 80 -100 0 -28 92 -120 121 -120 13 0 43 -23 79
-60 38 -40 66 -60 81 -60 15 0 37 -15 59 -40 25 -28 43 -40 62 -40 17 0 31 -8
38 -20 7 -13 21 -20 40 -20 19 0 33 -7 40 -20 7 -13 21 -20 40 -20 19 0 33 -7
40 -20 7 -13 21 -20 40 -20 19 0 33 -7 40 -20 8 -16 21 -20 60 -20 39 0 52 -4
60 -20 8 -16 21 -20 60 -20 39 0 52 -4 60 -20 9 -18 21 -20 100 -20 79 0 91
-2 100 -20 11 -20 19 -20 1803 -18 l1792 3 3 4272 c2 4264 2 4272 -18 4283
-19 10 -20 21 -20 320 0 300 1 309 20 315 11 3 20 13 20 20 0 8 -9 19 -20 25
-11 6 -20 17 -20 25 0 7 9 17 20 20 20 6 20 15 20 595 0 573 -1 590 -19 600
-12 6 -21 23 -23 43 l-3 32 -831 3 c-457 1 -834 -1 -837 -5z m-927 -3573 c10
-19 23 -20 463 -22 l452 -3 3 -592 c2 -584 2 -592 -18 -603 -20 -11 -20 -19
-20 -1160 0 -1139 0 -1149 20 -1160 18 -10 20 -21 20 -119 0 -101 -2 -110 -22
-125 l-23 -16 23 -16 c19 -14 22 -25 22 -85 0 -58 -3 -70 -20 -79 -11 -6 -20
-17 -20 -25 0 -7 9 -17 20 -20 14 -4 20 -15 20 -35 0 -20 -6 -31 -20 -35 -11
-3 -20 -13 -20 -20 0 -8 9 -19 20 -25 18 -10 20 -21 20 -140 0 -119 -2 -130
-20 -140 -13 -7 -20 -21 -20 -40 0 -20 6 -31 20 -35 11 -3 20 -13 20 -20 0 -8
-9 -19 -20 -25 -18 -10 -20 -21 -20 -140 0 -119 2 -130 20 -140 18 -10 20 -21
20 -140 0 -119 -2 -130 -20 -140 -18 -10 -20 -23 -22 -223 l-3 -212 -672 -3
c-664 -2 -672 -2 -683 18 -7 13 -21 20 -40 20 -19 0 -33 7 -40 20 -6 12 -21
20 -36 20 -35 0 -164 129 -164 164 0 15 -8 30 -20 36 -16 8 -20 21 -20 60 0
39 -4 52 -20 60 -20 11 -20 21 -20 2360 0 2339 0 2349 20 2360 16 8 20 21 20
60 0 39 4 52 20 60 12 6 20 21 20 36 0 35 129 164 164 164 15 0 30 8 36 20 7
13 21 20 40 20 19 0 33 7 40 20 10 19 21 20 160 20 139 0 150 1 160 20 9 17
21 20 80 20 59 0 71 -3 80 -20z M26240 10820 c-10 -18 -21 -20 -120 -20 -99 0
-110 -2 -120 -20 -9 -18 -21 -20 -100 -20 -79 0 -91 -2 -100 -20 -8 -16 -21
-20 -60 -20 -39 0 -52 -4 -60 -20 -8 -16 -21 -20 -60 -20 -39 0 -52 -4 -60
-20 -7 -13 -21 -20 -40 -20 -19 0 -33 -7 -40 -20 -7 -13 -21 -20 -40 -20 -19
0 -33 -7 -40 -20 -7 -12 -21 -20 -38 -20 -19 0 -37 -12 -62 -40 -23 -26 -44
-40 -60 -40 -16 0 -37 -14 -60 -40 -21 -24 -44 -40 -58 -40 -31 0 -322 -291
-322 -322 0 -14 -16 -37 -40 -58 -28 -25 -40 -43 -40 -62 0 -17 -8 -31 -20
-38 -12 -7 -20 -21 -20 -38 0 -19 -12 -37 -40 -62 -28 -25 -40 -43 -40 -62 0
-17 -8 -31 -20 -38 -16 -8 -20 -21 -20 -60 0 -39 -4 -52 -20 -60 -16 -8 -20
-21 -20 -60 0 -39 -4 -52 -20 -60 -18 -9 -20 -21 -20 -100 0 -79 -2 -91 -20
-100 -19 -10 -20 -21 -20 -220 0 -199 -1 -210 -20 -220 -20 -11 -20 -21 -20
-1860 0 -1839 0 -1849 20 -1860 19 -10 20 -21 20 -300 0 -279 1 -290 20 -300
18 -9 20 -21 20 -100 0 -79 2 -91 20 -100 16 -8 20 -21 20 -60 0 -39 4 -52 20
-60 13 -7 20 -21 20 -40 0 -19 7 -33 20 -40 13 -7 20 -21 20 -40 0 -19 7 -33
20 -40 13 -7 20 -21 20 -40 0 -19 7 -33 20 -40 13 -7 20 -21 20 -40 0 -19 7
-33 20 -40 12 -7 20 -21 20 -38 0 -19 12 -37 40 -62 26 -23 40 -44 40 -60 0
-16 14 -37 40 -60 24 -21 40 -44 40 -58 0 -30 211 -242 241 -242 13 0 50 -30
99 -80 53 -55 86 -80 102 -80 14 0 36 -15 58 -40 25 -28 43 -40 62 -40 17 0
31 -8 38 -20 7 -12 21 -20 38 -20 19 0 37 -12 62 -40 25 -28 43 -40 62 -40 17
0 31 -8 38 -20 7 -13 21 -20 40 -20 19 0 33 -7 40 -20 8 -16 21 -20 60 -20 39
0 52 -4 60 -20 8 -16 21 -20 60 -20 39 0 52 -4 60 -20 8 -16 21 -20 60 -20 39
0 52 -4 60 -20 9 -17 21 -20 80 -20 59 0 71 -3 80 -20 9 -18 21 -20 100 -20
79 0 91 -2 100 -20 10 -19 21 -20 240 -20 219 0 230 -1 240 -20 10 -19 23 -20
503 -22 l492 -3 3 -292 c2 -284 2 -292 -18 -303 -17 -9 -20 -21 -20 -80 0 -59
-3 -71 -20 -80 -13 -7 -20 -21 -20 -40 0 -19 -7 -33 -20 -40 -12 -6 -20 -21
-20 -36 0 -35 -129 -164 -164 -164 -15 0 -30 -8 -36 -20 -8 -16 -21 -20 -60
-20 -39 0 -52 -4 -60 -20 -10 -19 -21 -20 -320 -20 -299 0 -310 -1 -320 -20
-10 -19 -21 -20 -400 -20 -379 0 -390 1 -400 20 -10 19 -21 20 -360 20 -337 0
-350 -1 -360 -20 -9 -17 -23 -20 -103 -22 l-92 -3 0 -715 0 -715 1292 -3
c1284 -2 1292 -2 1303 18 10 18 21 20 140 20 119 0 130 2 140 20 9 17 21 20
80 20 59 0 71 3 80 20 8 16 21 20 60 20 39 0 52 4 60 20 8 16 21 20 60 20 39
0 52 4 60 20 7 13 21 20 40 20 19 0 33 7 40 20 7 13 21 20 40 20 19 0 33 7 40
20 7 13 21 20 40 20 19 0 33 7 40 20 7 12 21 20 38 20 19 0 37 12 62 40 22 25
44 40 58 40 16 0 49 25 102 80 50 51 86 80 100 80 28 0 80 52 80 80 0 14 35
56 100 120 74 73 100 105 100 124 0 15 8 30 20 36 13 7 20 21 20 40 0 19 7 33
20 40 13 7 20 21 20 40 0 19 7 33 20 40 13 7 20 21 20 40 0 19 7 33 20 40 13
7 20 21 20 40 0 19 7 33 20 40 16 8 20 21 20 60 0 39 4 52 20 60 16 8 20 21
20 60 0 39 4 52 20 60 16 8 20 21 20 60 0 39 4 52 20 60 18 10 20 21 20 140 0
119 2 130 20 140 20 11 20 19 18 4443 l-3 4432 -1712 3 c-1704 2 -1712 2
-1723 -18z m1718 -3917 c2 -2422 2 -2452 -17 -2463 -15 -8 -21 -23 -23 -63
l-3 -52 -172 -3 c-160 -2 -173 -4 -183 -22 -10 -19 -22 -20 -400 -20 -379 0
-390 1 -400 20 -9 17 -21 20 -80 20 -59 0 -71 3 -80 20 -7 13 -21 20 -40 20
-19 0 -33 7 -40 20 -6 12 -21 20 -36 20 -35 0 -204 169 -204 204 0 15 -8 30
-20 36 -13 7 -20 21 -20 40 0 19 -7 33 -20 40 -13 7 -20 21 -20 40 0 19 -7 33
-20 40 -20 11 -20 21 -20 2080 0 2059 0 2069 20 2080 16 8 20 21 20 60 0 39 4
52 20 60 12 6 20 21 20 36 0 35 129 164 164 164 15 0 30 8 36 20 7 13 21 20
40 20 19 0 33 7 40 20 11 20 19 20 723 18 l712 -3 3 -2452z M32120 10820 c-10
-18 -21 -20 -140 -20 -119 0 -130 -2 -140 -20 -9 -17 -21 -20 -80 -20 -59 0
-71 -3 -80 -20 -9 -17 -21 -20 -80 -20 -59 0 -71 -3 -80 -20 -7 -13 -21 -20
-40 -20 -19 0 -33 -7 -40 -20 -8 -16 -21 -20 -60 -20 -39 0 -52 -4 -60 -20 -7
-13 -21 -20 -40 -20 -19 0 -33 -7 -40 -20 -7 -12 -21 -20 -38 -20 -19 0 -37
-12 -62 -40 -22 -25 -44 -40 -59 -40 -15 0 -43 -20 -81 -60 -35 -36 -66 -60
-79 -60 -29 0 -241 -212 -241 -241 0 -13 -24 -44 -60 -79 -43 -41 -60 -65 -60
-84 0 -15 -8 -30 -20 -36 -12 -7 -20 -21 -20 -38 0 -19 -12 -37 -40 -62 -36
-31 -40 -40 -40 -82 0 -37 -4 -50 -20 -58 -13 -7 -20 -21 -20 -40 0 -19 -7
-33 -20 -40 -17 -9 -20 -21 -20 -80 0 -59 -3 -71 -20 -80 -18 -9 -20 -21 -20
-100 0 -79 -2 -91 -20 -100 -20 -11 -20 -21 -20 -2620 0 -2599 0 -2609 20
-2620 18 -9 20 -21 20 -100 0 -79 2 -91 20 -100 17 -9 20 -21 20 -80 0 -59 3
-71 20 -80 16 -8 20 -21 20 -60 0 -39 4 -52 20 -60 13 -7 20 -21 20 -40 0 -19
7 -33 20 -40 13 -7 20 -21 20 -40 0 -19 7 -33 20 -40 12 -7 20 -21 20 -38 0
-19 12 -37 40 -62 25 -22 40 -44 40 -59 0 -15 20 -43 60 -81 37 -35 60 -66 60
-79 0 -29 132 -161 161 -161 13 0 44 -23 79 -60 38 -40 66 -60 81 -60 15 0 37
-15 59 -40 25 -28 43 -40 62 -40 17 0 31 -8 38 -20 7 -13 21 -20 40 -20 19 0
33 -7 40 -20 7 -13 21 -20 40 -20 19 0 33 -7 40 -20 7 -13 21 -20 40 -20 19 0
33 -7 40 -20 8 -16 21 -20 60 -20 39 0 52 -4 60 -20 8 -16 21 -20 60 -20 39 0
52 -4 60 -20 9 -18 21 -20 100 -20 79 0 91 -2 100 -20 11 -20 21 -20 1040 -20
1019 0 1029 0 1040 20 9 18 21 20 100 20 79 0 91 2 100 20 8 16 21 20 60 20
39 0 52 4 60 20 8 16 21 20 60 20 39 0 52 4 60 20 8 16 21 20 60 20 39 0 52 4
60 20 7 13 21 20 40 20 19 0 33 7 40 20 7 12 21 20 38 20 19 0 37 12 62 40 22
25 44 40 59 40 15 0 43 20 81 60 35 36 66 60 79 60 29 0 241 212 241 241 0 13
24 44 60 79 43 41 60 65 60 84 0 15 8 30 20 36 13 7 20 21 20 40 0 19 7 33 20
40 13 7 20 21 20 40 0 19 7 33 20 40 13 7 20 21 20 40 0 19 7 33 20 40 16 8
20 21 20 60 0 39 4 52 20 60 16 8 20 21 20 60 0 39 4 52 20 60 18 9 20 21 20
100 0 79 2 91 20 100 20 11 20 21 20 2620 0 2599 0 2609 -20 2620 -18 10 -20
21 -20 120 0 99 -2 110 -20 120 -16 8 -20 21 -20 60 0 39 -4 52 -20 60 -16 8
-20 21 -20 60 0 39 -4 52 -20 60 -13 7 -20 21 -20 40 0 19 -7 33 -20 40 -13 7
-20 21 -20 40 0 19 -7 33 -20 40 -13 7 -20 21 -20 40 0 19 -7 33 -20 40 -12 6
-20 21 -20 36 0 19 -17 43 -60 84 -36 35 -60 66 -60 79 0 29 -212 241 -241
241 -13 0 -44 24 -79 60 -38 40 -66 60 -81 60 -15 0 -37 15 -59 40 -25 28 -43
40 -62 40 -17 0 -31 8 -38 20 -7 13 -21 20 -40 20 -19 0 -33 7 -40 20 -8 16
-21 20 -60 20 -39 0 -52 4 -60 20 -7 13 -21 20 -40 20 -19 0 -33 7 -40 20 -9
17 -21 20 -80 20 -59 0 -71 3 -80 20 -9 17 -21 20 -80 20 -59 0 -71 3 -80 20
-10 18 -21 20 -140 20 -119 0 -130 2 -140 20 -11 20 -21 20 -800 20 -779 0
-789 0 -800 -20z m680 -1440 c10 -19 21 -20 340 -20 319 0 330 -1 340 -20 7
-12 21 -20 38 -20 19 0 37 -12 62 -40 22 -25 44 -40 58 -40 13 0 37 -13 53
-29 16 -16 29 -40 29 -53 0 -14 15 -36 40 -58 39 -34 40 -36 40 -102 0 -57 3
-69 20 -78 20 -11 20 -21 20 -2320 0 -2299 0 -2309 -20 -2320 -16 -8 -20 -21
-20 -60 0 -39 -4 -52 -20 -60 -12 -6 -20 -21 -20 -36 0 -18 -29 -53 -110 -134
-107 -107 -111 -110 -154 -110 -35 0 -48 -5 -56 -20 -10 -20 -21 -20 -520 -20
-499 0 -510 0 -520 20 -8 15 -21 20 -56 20 -43 0 -47 3 -154 110 -81 81 -110
116 -110 134 0 15 -8 30 -20 36 -17 9 -20 21 -20 80 0 59 -3 71 -20 80 -20 11
-20 21 -20 2280 0 2259 0 2269 20 2280 17 9 20 21 20 80 0 59 3 71 20 80 12 6
20 21 20 36 0 35 169 204 204 204 15 0 30 8 36 20 7 13 21 20 40 20 19 0 33 7
40 20 10 18 21 20 140 20 119 0 130 2 140 20 8 16 21 20 60 20 39 0 52 -4 60
-20z"/></g>
  </svg>
)
